import { CommonModule } from "@angular/common";
import { ComponentFactoryResolver, NgModule } from "@angular/core";
import { MatIconModule } from "@angular/material/icon";
import { MatLegacyButtonModule as MatButtonModule } from "@angular/material/legacy-button";
import { MatLegacyFormFieldModule as MatFormFieldModule } from "@angular/material/legacy-form-field";
import { MatLegacyInputModule as MatInputModule } from "@angular/material/legacy-input";
import { MatLegacyMenuModule as MatMenuModule } from "@angular/material/legacy-menu";
import { TranslateModule } from "@ngx-translate/core";
import { DialogLayoutModule } from "@obg/mat.ui.core";
import { MatGlobalModule } from "@obg/mat.ui.global";
import { RouterModule } from "@obg/ngx.router";
import { CompactFooterModule, ComponentFactoryService, CoreUiModule } from "@obg/ngx.ui.core";
import { GlobalUiModule } from "@obg/ngx.ui.global";

import { VerificationDialogContainer } from "./verification-dialog.container";

@NgModule({
	imports: [
		CommonModule,
		MatButtonModule,
		MatMenuModule,
		MatFormFieldModule,
		MatIconModule,
		MatInputModule,
		DialogLayoutModule,
		TranslateModule,
		CompactFooterModule,
		CoreUiModule,
		GlobalUiModule,
		MatGlobalModule,
		RouterModule,
	],
	exports: [VerificationDialogContainer],
	declarations: [VerificationDialogContainer],
})
export class VerificationDialogModule {
	constructor(resolver: ComponentFactoryResolver, componentFactoryService: ComponentFactoryService) {
		componentFactoryService.registerLazyLoadedResolver(resolver, VerificationDialogContainer);
	}
}
